// components/features/intelligence/lensColors.js

const C = {
  gold: '#c8a96e', goldBg: 'rgba(200,169,110,0.08)', goldBorder: 'rgba(200,169,110,0.25)',
  sage: '#7a9e82', sageBg: 'rgba(122,158,130,0.08)', sageBorder: 'rgba(122,158,130,0.25)',
  purple: '#9b8fc4', purpleBg: 'rgba(155,143,196,0.08)', purpleBorder: 'rgba(155,143,196,0.25)',
  terra: '#c46050', terraBg: 'rgba(196,96,80,0.08)', terraBorder: 'rgba(196,96,80,0.25)',
};

const LENS_COLORS = {
  'Hidden Assumption': { color: C.terra, border: C.terraBorder, bg: C.terraBg },
  'hidden_assumption': { color: C.terra, border: C.terraBorder, bg: C.terraBg },
  'Gap Analysis': { color: C.purple, border: C.purpleBorder, bg: C.purpleBg },
  'gap': { color: C.purple, border: C.purpleBorder, bg: C.purpleBg },
  'Pattern': { color: C.gold, border: C.goldBorder, bg: C.goldBg },
  'pattern': { color: C.gold, border: C.goldBorder, bg: C.goldBg },
  'Blind Spot': { color: C.terra, border: C.terraBorder, bg: C.terraBg },
  'Contradiction': { color: C.terra, border: C.terraBorder, bg: C.terraBg },
  'contradiction': { color: C.terra, border: C.terraBorder, bg: C.terraBg },
  'Opportunity': { color: C.sage, border: C.sageBorder, bg: C.sageBg },
  'Strength': { color: C.sage, border: C.sageBorder, bg: C.sageBg },
  'Risk': { color: C.terra, border: C.terraBorder, bg: C.terraBg },
  'binding_constraint': { color: C.gold, border: C.goldBorder, bg: C.goldBg },
  'convergence': { color: C.gold, border: C.goldBorder, bg: C.goldBg },
  'causal_chain': { color: C.gold, border: C.goldBorder, bg: C.goldBg },
  'cross_domain': { color: C.purple, border: C.purpleBorder, bg: C.purpleBg },
  'indicator': { color: C.sage, border: C.sageBorder, bg: C.sageBg },
  'structural_insight': { color: C.purple, border: C.purpleBorder, bg: C.purpleBg },
  'structural_trap': { color: C.terra, border: C.terraBorder, bg: C.terraBg },
  'breakthrough': { color: C.gold, border: C.goldBorder, bg: C.goldBg },
  'decision': { color: C.gold, border: C.goldBorder, bg: C.goldBg },
  'reframe': { color: C.purple, border: C.purpleBorder, bg: C.purpleBg },
  'idea_worth_keeping': { color: C.gold, border: C.goldBorder, bg: C.goldBg },
  'key_question': { color: C.purple, border: C.purpleBorder, bg: C.purpleBg },
  'next_experiment': { color: C.sage, border: C.sageBorder, bg: C.sageBg },
  default: { color: C.gold, border: C.goldBorder, bg: C.goldBg },
};

export function getLensColor(lensType) {
  return LENS_COLORS[lensType] || LENS_COLORS.default;
}
